// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__1VDjo","navText":"Navbar_navText__18S8a","navLogo":"Navbar_navLogo__2pDv8","imgLogo":"Navbar_imgLogo__3R7_O"};